// 毫秒转换
/*
 * 示例  format(时间戳，yyyy-MM-dd hh:mm)
 */
import moment from 'moment'

export function format(time, format) {
  if (!time) {
    return ''
  }
  const t = new Date(time)
  const tf = (i) => {
    return (i < 10 ? '0' : '') + i
  }
  return format.replace(/yyyy|MM|dd|hh|mm|ss/g, (a) => {
    switch (a) {
      case 'yyyy':
        return tf(t.getFullYear())
      case 'MM':
        return tf(t.getMonth() + 1)
      case 'dd':
        return tf(t.getDate())
      case 'hh':
        return tf(t.getHours())
      case 'mm':
        return tf(t.getMinutes())
      case 'ss':
        return tf(t.getSeconds())
    }
  })
}

export const reviewStatus = (val) => {
  switch (val) {
    case 0:
      return '草稿'
    case 1:
      return '待审核'
    case 2:
      return '审核通过'
    case 3:
      return '审核拒绝'
    case 4:
      return '撤销审核'
  }
}
export const arrayConvertString = val => {
  return val.toString()
}
export const statusGoodsShelves = val => {
  switch (val) {
    case 0:
      return '未上架'
    case 1:
      return '上架中'
    case 2:
      return '已上架'
    case 3:
      return '已下架'
    case 4:
      return '未知'
  }
}

export const adProjectStatus = (val) => {
  const status = {
    0: '起草中',
    1: '起草中',
    2: '起草中',
    3: '待审核',
    4: '已审核',
    5: '未通过'
  }
  return status[val]
}

export const adSettleStatus = (val) => {
  const status = {
    0: '整单结算',
    1: '月度暂结',
    2: '整单暂结'
  }
  return status[val]
}

export const adSettleSource = (val) => {
  const status = {
    1: '秒针IES',
    2: '乐播云',
    3: '客户数据-实结',
    4: '客户数据-全结',
    5: '历史结算导入'
  }
  return status[val]
}

export const refundStatus = (val) => {
  switch (val) {
    case 0:
      return '未申请'
    case 1:
      return '待处理'
    case 2:
      return '已退款'
    case 3:
      return '拒绝退款'
  }
}

export const fixStatus = (val) => {
  switch (val) {
    case 0:
      return '未申请'
    case 1:
      return '待处理'
    case 2:
      return '已补单'
    case 3:
      return '已拒绝'
  }
}

export const invoiceStatus = (val) => {
  switch (val) {
    case 0:
      return '未申请'
    case 1:
      return '待开票'
    case 2:
      return '已开票'
    case 3:
      return '开票失败'
  }
}

export const payType = (val) => {
  switch (val) {
    case 1:
      return '微信'
    case 2:
      return '支付宝'
    case 5:
      return 'IOS内购'
  }
}

export function optionsPipe(value, options, field = 'label') {
  if (
    options.length === 0 ||
    value === '' ||
    value === null ||
    value === undefined
  ) {
    return value
  }
  const find = options.find(option => option.value == value)
  return typeof find === 'object' ? find[field] : 'N/A'
}

export function datePipe(value, formatString = 'YYYY-MM-DD HH:mm:ss') {
  return value ? moment(value).format(formatString) : value
}

export function mapUserTagsToDict(userTags, dic) {
  // 该过滤器用于表格单元格渲染，字典异步加载未完成或值为空时若抛异常会打断整表渲染，
  // 故此处只做容错兜底，匹配逻辑保持不变
  if (userTags === null || userTags === undefined) {
    return '-'
  }
  const dictList = Array.isArray(dic) ? dic : []
  const userTagsArray = String(userTags).split(',').map(tag => tag.trim());
  const matchedDictValues = userTagsArray.map(userTag => {
    const matchingDict = dictList.find(dict => dict.dictKey === userTag);
    return matchingDict ? matchingDict.dictValue : '未知';
  });
  return matchedDictValues.join(', '); // 以逗号分隔
}

/** 秒数转换 00:02:31的格式 */
export function secondsToStandardization(seconds) {
  if (!seconds) {
    return '-'
  }
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

/** 小写转大写 */
export function totoLowerCase(value) {
  if (!value) {
    return ''
  }
  return value.toLowerCase()
}

/** 去除对象里的空属性(null,"",undefined) */
export function removeEmpty(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const element = obj[key];
      if (element === null || element === '' || element === undefined) {
        delete obj[key]
      }
    }
  }
  return obj
}
/** 要将对象B的属性复制到对象A中，同时只保留对象A原有的属性，可以遍历对象A的键，并从对象B中复制相应的值  */
export function mergeObjects(target, source) {
  // 遍历目标对象的每个键
  Object.keys(target).forEach(key => {
    if (source.hasOwnProperty(key)) {
      // 如果源对象有相同的键，则复制其值
      target[key] = source[key];
    }
  });
}

/** 空数据转短横线 */
export function emptyToDash(value) {
  if (!value) {
    return '-'
  }
  return value
}
